import * as yup from 'yup'

const schema = yup.object().shape({
  email: yup.string().email(),
})

export const isEmailValid = (email: string) => !!email && schema.isValidSync({ email })
